import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectLanguage, selectRole, setDoctorId } from '../Login/loginSlice';
import { selectUserId } from '../Login/loginSlice';
import { texts } from '../Common/common';
import { getWeeklyOrders } from './diaryApi';
import { useNavigate } from 'react-router-dom';
import { setShowDoctorOrders } from '../Lab/labSlice';
import {
  setOrder,
  setPacient,
  setPaid,
  setTechnicId,
  setPrice,
  setColor,
  setDoctorName,
  setDoctorCompany,
  setPhotos,
  setAudios,
  setComments,
  setShowOrderCard,
} from '../Lab/Orders/orderSlice';
import { getOrderAudios, getOrderComments, getOrderPhotos } from '../Lab/Orders/orderApi';
import './diary.css';

function diffDate(date) {
  const d1 = new Date();
  const d2 = new Date(date);
  const timeDiff = d2.getTime() - d1.getTime();
  return Math.floor(timeDiff / (1000 * 3600 * 24));
}

const Diary = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const role = useSelector(selectRole);
  const user_id = useSelector(selectUserId);
  const currentLanguage = useSelector(selectLanguage);

  const [weeksData, setWeeksData] = useState([]);
  const [currentWeekIndex, setCurrentWeekIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(() => {
    setLoading(true);
    getWeeklyOrders({ date_start: '2023-01-01', date_end: '2025-12-31', user_id }, (data) => {
      if (data.res) {
        setWeeksData(data.weeks);
        if (data.weeks.length > 0) setCurrentWeekIndex(data.weeks.length - 1);
      } else {
        alert('Ошибка загрузки данных');
      }
      setLoading(false);
    });
  }, [user_id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const currentWeek = weeksData[currentWeekIndex];

  const handlePressOrder = (order) => {
    dispatch(setOrder(order));
    dispatch(setPacient(order.pacient));
    dispatch(setPaid(order.paid));
    dispatch(setTechnicId(order.technic_id));
    dispatch(setPrice(order.price));
    dispatch(setColor(order.color));
    dispatch(setDoctorName(order.doctor_name));
    dispatch(setDoctorCompany(order.company));
    dispatch(setDoctorId(order.doctor_id));

    getOrderPhotos({ order_id: order.id }, (data) => dispatch(setPhotos(data.photos)));
    getOrderAudios({ order_id: order.id }, (data) => dispatch(setAudios(data.audios)));
    getOrderComments({ order_id: order.id }, (data) => dispatch(setComments(data.audios)));

    dispatch(setShowDoctorOrders(true));
    dispatch(setShowOrderCard(true));
    navigate('/dentapp/lab');
  };

  if (role === 'doctor') return null;

  return (
    <div className="diary-container">
      <div className="diary-header">
        <h2 className="title">{texts[currentLanguage].diary}</h2>
        <div className="week-period">{texts[currentLanguage].week}: {currentWeek?.period}</div>
      </div>

      {loading ? (
        <div className="loader">Загрузка...</div>
      ) : currentWeek ? (
        <>
          <div className="week">
            {currentWeek.days.map((day, di) => (
              <div key={di} className="day">
                <div className="day-name">{day.name}</div>
                {day.orders.map((order, i) => (
                  <button
                    key={i}
                    className={['order-item', [-1,0,1].includes(diffDate(order.date_delivery)) ? 'urgent' : ''].join(' ')}
                    onClick={() => handlePressOrder(order)}
                  >
                    <div className="row">
                      <span className="label">{texts[currentLanguage].dentistLabel}</span>
                      <span className="value">{order.doctor_name}</span>
                    </div>
                    <div className="row">
                      <span className="label">{texts[currentLanguage].patientLabel}</span>
                      <span className="value">{order.pacient}</span>
                    </div>
                  </button>
                ))}
              </div>
            ))}
          </div>

          <div className="nav-row">
            <button
              className="nav-btn"
              onClick={() => setCurrentWeekIndex((v) => Math.max(0, v - 1))}
              disabled={currentWeekIndex === 0}
            >
              {texts[currentLanguage].back}
            </button>
            <button
              className="nav-btn"
              onClick={() => setCurrentWeekIndex((v) => Math.min(weeksData.length - 1, v + 1))}
              disabled={currentWeekIndex === weeksData.length - 1}
            >
              {texts[currentLanguage].next}
            </button>
          </div>
        </>
      ) : (
        <div className="empty">Нет данных</div>
      )}
    </div>
  );
};

export default Diary;
